module.exports = {
    /**
     * Нужен пока нет бэкенда, разделение на мультиплексы нужны для
     * возможности раздельного выключения, конфиг хранится в бункере
     * @param {Object} map
     * @param {String} familyId
     * @returns {String}
     */
    familyIdMapHDContentId(map, familyId) {
        if (map) {
            const multiplexChannels = map.multiplexChannels && map.multiplexChannels.enabled && map.multiplexChannels[familyId];
            const otherChannels = map.otherChannels && map.otherChannels.enabled && map.otherChannels[familyId];
            return multiplexChannels || otherChannels;
        }

        return;
    },
};
